// Tarifs de livraison World Express par wilaya
// Format: { wilaya: { home: prix_domicile, desk: prix_stop_desk } }

export const SHIPPING_RATES = {
  'Adrar': { home: 1400, desk: 1100 },
  'Chlef': { home: 850, desk: 450 },
  'Laghouat': { home: 1000, desk: 700 },
  'Oum El Bouaghi': { home: 850, desk: 500 },
  'Batna': { home: 850, desk: 500 },
  'Béjaïa': { home: 850, desk: 500 },
  'Biskra': { home: 950, desk: 600 },
  'Béchar': { home: 1400, desk: 1100 },
  'Blida': { home: 700, desk: 450 },
  'Bouira': { home: 850, desk: 450 },
  'Tamanrasset': { home: 1800, desk: 1400 },
  'Tébessa': { home: 950, desk: 600 },
  'Tlemcen': { home: 850, desk: 500 },
  'Tiaret': { home: 850, desk: 500 },
  'Tizi Ouzou': { home: 850, desk: 450 },
  'Alger': { home: 500, desk: 400 },
  'Djelfa': { home: 900, desk: 600 },
  'Jijel': { home: 850, desk: 500 },
  'Sétif': { home: 850, desk: 450 },
  'Saïda': { home: 900, desk: 600 },
  'Skikda': { home: 850, desk: 500 },
  'Sidi Bel Abbès': { home: 850, desk: 500 },
  'Annaba': { home: 850, desk: 500 },
  'Guelma': { home: 900, desk: 600 },
  'Constantine': { home: 850, desk: 450 },
  'Médéa': { home: 850, desk: 450 },
  'Mostaganem': { home: 850, desk: 500 },
  'M\'Sila': { home: 850, desk: 500 },
  'Mascara': { home: 900, desk: 600 },
  'Ouargla': { home: 1100, desk: 800 },
  'Oran': { home: 850, desk: 450 },
  'El Bayadh': { home: 1100, desk: 800 },
  'Illizi': { home: 2000, desk: 1700 },
  'Bordj Bou Arreridj': { home: 850, desk: 450 },
  'Boumerdès': { home: 700, desk: 450 },
  'El Tarf': { home: 950, desk: 600 },
  'Tindouf': { home: 1800, desk: 1400 },
  'Tissemsilt': { home: 850, desk: 500 },
  'El Oued': { home: 1100, desk: 800 },
  'Khenchela': { home: 900, desk: 600 },
  'Souk Ahras': { home: 900, desk: 600 },
  'Tipaza': { home: 700, desk: 450 },
  'Mila': { home: 850, desk: 500 },
  'Aïn Defla': { home: 850, desk: 450 },
  'Naama': { home: 1100, desk: 800 },
  'Aïn Témouchent': { home: 900, desk: 600 },
  'Ghardaïa': { home: 1100, desk: 800 },
  'Relizane': { home: 850, desk: 500 },
  'Timimoun': { home: 1400, desk: 1100 },
  'Ouled Djellal': { home: 1000, desk: 700 },
  'Béni Abbès': { home: 1400, desk: 1100 },
  'In Salah': { home: 1400, desk: 1100 },
  'In Guezzam': { home: 2000, desk: 1700 },
  'Touggourt': { home: 1100, desk: 800 },
  'Djanet': { home: 2000, desk: 1700 },
  'El M\'Ghair': { home: 1100, desk: 800 },
  'El Meniaa': { home: 1300, desk: 1000 }
};

// Fonction pour obtenir le tarif de livraison
export const getShippingRate = (wilaya, deliveryMethod) => {
  const rates = SHIPPING_RATES[wilaya];
  if (!rates) return 0;
  
  if (deliveryMethod === 'home_delivery') {
    return rates.home;
  } else if (deliveryMethod === 'stop_desk') {
    return rates.desk;
  } else if (deliveryMethod === 'pickup') {
    return 0; // Retrait en magasin = gratuit
  }
  
  return 0;
};

export default SHIPPING_RATES;
